import React from 'react';
import { global, input, weekDays, } from "../translate";
import { sortableKeyboardCoordinates, useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { KeyboardSensor, MouseSensor, TouchSensor, useSensor, useSensors } from "@dnd-kit/core";

import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
const { REACT_APP_SERVER } = process.env;
let color = REACT_APP_SERVER === 'ATS' ? '#0973b9' : '#7ebc0a'
const styles = {
    width: '40%',
    height: 35,
    border: '1px solid black',
    textAlign: "center",
    fontSize: 14
}
function ShortLine({ setForm, s, handleDelete, sip, index, dragDisabled = false, showOrder = false }) {
    const { attributes, listeners, setNodeRef, transform, transition } =
        useSortable({ id: s.id, disabled: dragDisabled });
    const style = {
        transition,
        transform: CSS.Transform.toString(transform),
    };
    const mouseSensor = useSensor(MouseSensor, {
        activationConstraint: {
            distance: 8,
        },
    });
    const touchSensor = useSensor(TouchSensor, {
        activationConstraint: {
            delay: 200,
            tolerance: 6,
        },
    });
    const handleTime = (name, value) => {
        const input = value;
        setForm((prev) => ({
            ...prev,
            sip: prev.sip.map((l, i) => {
                if (i === index) {
                    if (/^([0-9]{0,2}):?([0-9]{0,2})?$/.test(input) || input === '') {
                        return { ...l, [name]:input}
                    }

                    return { ...l}; // ✅ creates a new object
                }
                return l;
            })
        }));
    };

    const handleBlur = (name) => {
        setForm((prev) => ({
            ...prev,
            sip: prev.sip.map((l, i) => {
                if (i === index) {
                    const [hours, minutes] = l[name].split(':').map(Number);
                    const formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
                    return { ...l, [name]:formattedTime}; // ✅ creates a new object
                }
                return l;
            })
        }));
    };
    const sensors = useSensors(
        mouseSensor,
        touchSensor,
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );
    const handleTimeChange = (name, val) => {
        console.log(index);

        setForm((prev) => ({
            ...prev,
            sip: prev.sip.map((l, i) => {

                if (i === index) {
                    return { ...l, [name]: val }; // ✅ creates a new object
                }
                return l;
            })
        }));


    };
    return (

        <div style={{ ...style, width: 'fit-content', margin: '10px 0' }} ref={setNodeRef} {...sensors} {...attributes}
            className="d-flex flex-row text-center">
            <div style={{ width: 170, textAlign: 'left', display: 'flex', alignItems: 'center' }}>
                {showOrder && (
                    <span style={{ width: 20, textAlign: 'center', marginRight: 6 }}>
                        {index + 1}
                    </span>
                )}
                <span style={{ width: 40, display: 'inline-block', cursor: dragDisabled ? 'default' : 'grab' }} {...listeners}>
                    <DragIndicatorIcon sx={{ fontSize: 20 }} />
                </span>
                <span style={{ userSelect: 'text', pointerEvents: 'auto', marginLeft: 10 }}>
                    {s.num} {sip.find(k => k.buddy === s.num)?.issip ? '(S)' : ''} {s.num.includes('(') ? '()' : `(${s.notes})`}
                </span>
            </div>
            <div style={{ width: 150 }}>
                <select value={s.weekStart} onChange={(ev) => handleTimeChange('weekStart', ev.target.value)} style={{ ...styles }}>
                    <option>{input.select[+localStorage.getItem('atsLang') || 1]}</option>
                    {weekDays.map(k => (
                        <option key={k[+localStorage.getItem('atsLang') || 1]}
                            value={k[+localStorage.getItem('atsLang') || 1]}>{k[+localStorage.getItem('atsLang') || 1]}</option>
                    ))}
                </select>
                <span>-</span>
                <select value={s.weekEnd}
                    onChange={(ev) => handleTimeChange('weekEnd', ev.target.value)} style={{ ...styles }}>
                    <option>{input.select[+localStorage.getItem('atsLang') || 1]}</option>
                    {weekDays.map(k => (
                        <option key={k[+localStorage.getItem('atsLang') || 1]}
                            value={k[+localStorage.getItem('atsLang') || 1]}>{k[+localStorage.getItem('atsLang') || 1]}</option>
                    ))}
                </select>
            </div>
            <div style={{width: 150}}>
                <input
                    type="text"
                    value={s.timeStart}
                    onChange={(ev) => handleTime('timeStart',ev.target.value)}
                    onBlur={() => handleBlur('timeStart')}
                    placeholder="HH:mm"
                    style={{...styles}}
                />
                <span>-</span>
                <input
                    type="text"
                    value={s.timeEnd}
                    onChange={(ev) => handleTime('timeEnd',ev.target.value)}
                    onBlur={() => handleBlur('timeEnd')}
                    placeholder="HH:mm"
                    style={{...styles}}
                />
            </div>
            <div style={{ width: 150 }} className="d-flex justify-content-center">
                <span onClick={() => handleDelete(s.id)} className="deleteBtn"
                    style={{ background: 'red' }}>
                    {global.delete[+localStorage.getItem('atsLang') || 1]}
                </span>
            </div>
        </div>
    );
}

export default ShortLine;
